import {ReactNode} from 'react';
import styles from './styles.module.scss';
import BgGradientLeftIcon from '../page-template/assets/bg-gradient-left.svg?react';
import BgGradientRightIcon from '../page-template/assets/bg-gradient-right.svg?react';
import BaseCard from '../base-card';

type TwoPanePageProps = {
  children: ReactNode;
};

const TwoPanePage = ({children}: TwoPanePageProps) => {
  return (
    <div className={styles.background}>
      <BgGradientLeftIcon className={styles.bgGradientTop} />

      <BgGradientRightIcon className={styles.bgGradientBottom} />

      <div className={styles.mainPane}>
        <BaseCard
          style={{
            width: '100%',
          }}
        >
          {children}
        </BaseCard>
      </div>
    </div>
  );
};

export default TwoPanePage;
